import { i18n } from '@lingui/core';
import React from 'react';
import { useSearchData } from '../../data/SearchData';
import { ToriFiltersBottomMarker } from '../advertising/tori/ToriFiltersBottomMarker';
import { FilterItem } from './FilterItem';
import { FiltersSkipLinkTarget } from './FiltersSkipLink';

const FILTERS_HEADING_ID = 'filters-heading';

type FilterListProps = {
    className?: string;
    scrollToFilterAction?: () => string | null;
};

export function FilterList(props: FilterListProps) {
    const { className = '', scrollToFilterAction } = props;

    const scrollToFilter = scrollToFilterAction?.();

    const filterActionFn = React.useCallback(
        (filterElement: HTMLDivElement | null, filterName: string) => {
            if (filterElement) {
                if (scrollToFilter && filterName === scrollToFilter) {
                    filterElement.scrollIntoView({ behavior: 'smooth' });
                }
            }
        },
        [scrollToFilter],
    );

    const { searchData } = useSearchData();

    const filters = searchData?.filters?.filter(
        (filter) => filter.type !== 'QUERY_FILTER',
    );

    return (
        <section aria-labelledby={FILTERS_HEADING_ID} className={className}>
            <FiltersSkipLinkTarget />
            <h2 className="sr-only" id={FILTERS_HEADING_ID}>
                {i18n.t({
                    id: 'filters.desktop.heading',
                    message: 'Filters',
                })}
            </h2>
            <div className="space-y-24">
                {filters?.map((filter) => (
                    <FilterItem
                        filter={filter}
                        filterAction={filterActionFn}
                        key={filter.name}
                    />
                ))}
            </div>
            <ToriFiltersBottomMarker />
        </section>
    );
}
